<template>




    <div class="container">
        <div class="row justify-content-center">

            <div class="booking-container">

                <div v-if="isLoading" class="d-flex justify-content-center">
                    <loader></loader>
                </div>
                <div v-else>

                    <div class="row d-flex justify-content-center mb-4">
                        <div class="col-12 text-center ">
                            <h2 class="mb-4">Spa Garden</h2>
                            <p>Your Spa Day includes access to the Spa Garden</p>
                        </div>
                    </div>

                    <div class="row justify-content-center mb-4" v-if="!hasEnoughSlots && !canSubmit">
                        <div class="col-24 col-xl-12 d-flex justify-content-center">
                            <info-box v-bind:type="'error'">

                                <template v-slot:body>
                                    <strong>Please choose an alternative date or time for this experience.</strong>

                                </template>
                            </info-box>
                        </div>
                    </div>
                    <div v-else>
                        <div v-if="guests.length > 1" class="row justify-content-center">

                            <div class="row justify-content-center">
                                <div class="col-24 col-xl-12 d-flex justify-content-center">
                                    <div class="mb-4 bg-white  px-4 py-3">
                                        <label class="same-time">
                                            <input class="stacked-option" type="checkbox" v-model="showStacked" v-on:click="combinedSelected = null;" />
                                            Start all guests Spa Garden experience at the same time.

                                        </label>

                                    </div>
                                </div>

                            </div>
                        </div>



                        <div class="row mt-2" v-if="!showStacked">
                            <div v-for="(guest, gIndex) in guests" class="col-24 col-xl-12">
                                <div class="row mb-4">
                                    <div class="col-24 text-center">
                                        <h3>{{guest.firstName}}</h3>
                                    </div>
                                </div>
                                <div class="px-4">



                                    <div class="row" v-if="arrivalTimes != null && arrivalTimes.length && notAllBlocked">
                                        <div v-for="(arrivalTime, tImedex) in arrivalTimes"
                                             class="col-24  mb-2">

                                            <button class="btn btn--block time-slot "
                                                    v-bind:disabled="isDisabled(arrivalTime) && !isSelected(guest, arrivalTime)"
                                                    v-on:click="onClick(guest, arrivalTime)"
                                                    v-bind:class="{'time-slot--active': isSelected(guest, arrivalTime)}">


                                                {{formatTime(arrivalTime.StartDateTime)}}

                                            </button>
                                        </div>
                                    </div>
                                    <div class="row justify-content-center" v-else>
                                        <div class="col-18 d-flex justify-content-center">
                                            <info-box v-bind:type="'error'">

                                                <template v-slot:body>
                                                    <strong>Please choose an alternative date or time for this experience.</strong>

                                                </template>
                                            </info-box>

                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>


                        <div class="row mt-2 justify-content-center" v-else>

                            <div class="px-4 col-24 col-xl-12">

                                <div v-if="(combinedArrivalTimes != null && combinedArrivalTimes.length)  || canSubmit">
                                    <div class="row">
                                        <div class="row mb-4">
                                            <div class="col-24 text-center">
                                                <h3>Access time</h3>
                                            </div>
                                        </div>


                                        <div v-for="(arrivalTime, tImedex) in combinedArrivalTimes"
                                             class="col-24  mb-2">

                                            <button class="btn btn--block time-slot "
                                                    v-bind:disabled="isCombinedDisabled(arrivalTime) && !isCombinedSelected(arrivalTime) "
                                                    v-on:click="onCombinedClick(arrivalTime)"
                                                    v-bind:class="{'time-slot--active': isCombinedSelected(arrivalTime)}">
                                                {{formatTime(arrivalTime.StartDateTime)}}


                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="row justify-content-center" v-else>
                                    <div class="col-18 d-flex justify-content-center">
                                        <info-box v-bind:type="'error'">

                                            <template v-slot:body>
                                                <strong>Please choose an alternative date or time for this experience.</strong>

                                            </template>
                                        </info-box>

                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </div>



        </div>



    </div>






    <actions-bar>
        <template v-slot:actions>
            <div class="row">
                <div class="col-10">

                    <button v-on:click="onBack"
                            type="button"
                            class="btn btn--transparent btn--back">
                        Back
                    </button>
                </div>

                <div class="col-4 d-flex flex-column align-items-center">

                    <span v-if="total > 0" class="spa-total-label">Total</span>
                    <span v-if="total > 0" class="spa-total">&pound;{{total}}</span>

                </div>

                <div class="col-10 d-flex justify-content-end">
                    <button class="btn btn--slate-blue btn--continue"
                            v-bind:disabled="!canSubmit"
                            type="button"
                            v-on:click="onContinue()">
                        Next

                    </button>
                </div>
            </div>
        </template>
    </actions-bar>



</template>

<script>
    import { _ } from 'vue-underscore';
    import ActionsBar from '@/shared/components/ActionsBar.vue';
    import Loader from '@/shared/components/Loader.vue';
    import InfoBox from '@/shared/components/InfoBox.vue';
    import { store } from '../store/index';
    export default {
        name: 'SpaDayArrivalTme',

        components: {

            ActionsBar,
            Loader,
            InfoBox
        },

        mounted() {
            let o = this;
            o.isLoading = true;

            let payload = {
                date: moment(this.search.date).format("YYYY-MM-DD"),
                startDate: this.search?.guests[0]?.spaDayArrivalTime?.selectedItem?.StartDateTime,
                endDate: moment(this.search.date).format("YYYY-MM-DD") + "T" + this.search?.spaDay?.EndTime
            };

            console.log("payload", payload);

            store.dispatch("fetchGroupAvailability", payload).then((t) => {

                o.setupAvailability(t);

                let guests = [];

                for (let guestIndex = 0; guestIndex < this.search.guestCount; guestIndex++) {
                    let guest = this.search.guests[guestIndex];
                    guests.push({ title: guest.title, firstName: guest.firstName, lastName: guest.lastName, isLoggedInUser: guest.isLoggedInUser, arrivalTime: guest.spaDayArrivalTime, spaArrivalTime: null })
                }

                o.guests = guests;



                o.isLoading = false;
            }).catch((e) => {

                o.isLoading = false;
            });




        },
        data() {
            return {
                isLoading: false,
                guests: [],
                showStacked: true,
                combinedSelected: null,
                spaGardenAvailability: []
            }
        },
        computed: {
            hasEnoughSlots() {
                let filteredAvailability = this.filteredAvailability;

                let sum = filteredAvailability.reduce(function (previousValue, item) {
                    if (item.IsBlocked || false) {
                        return previousValue + 0;
                    }
                    else {
                        return previousValue + item.FilteredSpaces || 0;
                    }
                }, 0);

                return sum;
            },
            notAllBlocked() {
                let result = this.arrivalTime?.every(item => item.IsBlocked) ?? true;
                return result;
            },
            removedTimes() {

                let result = [];
                if (this.search?.restaurant != null) {
                    let duration = this.search?.restaurant?.duration ?? 120;
                    let diningAllocation = this.search?.restaurant?.selectedTime?.TimeSlot;
                    if (duration != null && diningAllocation != null) {

                        let minTime = moment(moment.utc(diningAllocation).add(-duration, 'm'));
                        let maxTime = moment(moment.utc(diningAllocation).add(duration, 'm'));

                        result = [minTime, maxTime]
                    }
                }


                return result;


            },

            onBack() {

                if (this.search.spaDay.HasDining) {
                    this.$router.push({ name: 'spa_day_dining', params: { id: this.session.Id } });
                }
                else {
                    this.$router.push({ name: 'spa_day_arrival_time', params: { id: this.session.Id } });
                }
            },

            filteredAvailability() {

                let result = [];
                let band = this.search.spaDay.bookingDetails.TimeBands.find(item => item.BandNumber == this.search.spaDay.Band);

                let bandStart = moment.utc(moment(this.search.date).format('YYYY-MM-DD') + 'T' + band.StartTime);
                let bandEnd = moment.utc(moment(this.search.date).format('YYYY-MM-DD') + 'T' + band.EndTime);






                let availability = this.spaGardenAvailability.filter(item => item.GroupAppointmentTypeID == this.search.spaDay.SpaGardenCode);

                for (let gi = 0; gi < availability.length; gi++) {
                    let thisItem = availability[gi];

                    let start = moment.utc(thisItem.StartDateTime);
                    let end = moment.utc(thisItem.EndDateTime);

                    if (start >= bandStart && end <= bandEnd) {

                        let guestsSelected = this.guests.filter(item => item.spaArrivalTime != null && item.spaArrivalTime.StartDateTime == thisItem.StartDateTime);
                        thisItem.FilteredSpaces = thisItem.NumberOfSpacesAvailable - guestsSelected.length;

                        if (thisItem.FilteredSpaces <= 0) {
                            thisItem.IsBlocked = true;
                        }
                        else {
                            thisItem.IsBlocked = false;
                        }

                        if (this.removedTimes.length) {
                            if (start >= this.removedTimes[0] && end <= this.removedTimes[1]) {
                                thisItem.IsBlocked = true;
                            }
                        }


                        //Not during dining
                        if (this.search?.restaurant != null) {
                            let duration = this.search?.restaurant?.duration ?? 120;
                            let diningAllocation = this.search?.restaurant?.selectedTime?.TimeSlot;
                            if (duration != null && diningAllocation != null) {

                                let minTime = moment.utc(diningAllocation).add(-duration, 'm');
                                let maxTime = moment.utc(diningAllocation).add(duration, 'm');

                                if (start.isBetween(minTime, maxTime) || end.isBetween(minTime, maxTime)) {
                                    thisItem.IsBlocked = true;
                                }


                            }
                        }




                        result.push(thisItem);
                    }


                    else {
                        thisItem.FilteredSpaces = thisItem.NumberOfSpacesAvailable;
                        thisItem.IsBlocked = true;
                    }

                }

                return result;
            },
            combinedArrivalTimes() {
                let o = this;

                let items = this.filteredAvailability;
                for (let i = 0; i < items.length; i++) {
                    let item = items[i];
                    if (item.FilteredSpaces < this.search.guests.length) {
                        item.IsBlocked = true;
                    }
                }

                return _.sortBy(items, function (item) {
                    return item.StartDateTime;
                });
            },
            arrivalTimes() {
                let items = this.filteredAvailability;

                return _.sortBy(items, function (item) {
                    return item.StartDateTime;
                });
            },
            canSubmit() {
                let aGuests = this.guests.filter(item => item.spaArrivalTime == null);
                return aGuests.length == 0;
            },

            session() {
                return store.getters.session
            },
            search() {
                return store.getters.search;
            },
            booking() {
                return store.getters.booking;
            },
            total() {
                return store.getters.dayTotal
            }
        },
        methods: {
            formatTime(item) {
                return moment(item).format("HH:mm");
            },
            setupAvailability(item) {
                this.spaGardenAvailability = item;

            },
            onContinue() {
                let payload = this.guests;
                store.dispatch("setSpaGardenTimes", payload).then(() => {
                    if (this.search.spaDay.HasTreatments) {
                        this.$router.push({ name: 'spa_day_treatments', params: { id: this.session.Id } });

                    }
                    else if (this.search.spaDay.HasExtras) {
                        this.$router.push({ name: 'spa_day_add_ons', params: { id: this.session.Id } });

                    }
                    else {
                        this.$router.push({ name: 'spa_day_details', params: { id: this.session.Id } });
                    }
                });
            },
            onClick(guest, time) {
                if (guest.spaArrivalTime == time) {
                    guest.spaArrivalTime = null;
                }
                else {
                    guest.spaArrivalTime = time;
                }
            },
            onCombinedClick(time) {
                this.combinedSelected = time;
                for (let gi = 0; gi < this.guests.length; gi++) {
                    let guest = this.guests[gi];
                    this.onClick(guest, time);
                }
            },
            isSelected(guest, spaArrivalTime) {

                if (guest.spaArrivalTime == null) {
                    return false;
                }
                return guest.spaArrivalTime?.StartDateTime == spaArrivalTime.StartDateTime;
            },
            isDisabled(arrivalTime) {

                return arrivalTime.IsBlocked;

            },
            isCombinedSelected(arrivalTime) {
                return this.combinedSelected?.StartDateTime == arrivalTime.StartDateTime;
            },
            isCombinedDisabled(arrivalTime) {

                return arrivalTime.IsBlocked;
            },
        }
    }
</script>

<style scoped>
    .time-slot {
        background: white;
        border-radius: 5px;
        margin-bottom: 20px;
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 20px;
        cursor: pointer !important;
        border: none;
    }

        .time-slot:disabled,
        .time-slot.timeslot--disabled,
        .time-slot.time-slot--unavailable {
            color: rgba(66, 82, 96, 1);
            cursor: not-allowed;
        }



        .time-slot:not(.time-slot--unavailable):hover,
        .time-slot.time-slot--active {
            background-color: #425260;
            color: #fff;
        }

    .spa .spa-total-label {
        font-weight: 300;
        display: block;
        font-size: 16px;
        text-align: center;
        text-transform: uppercase;
    }

    .spa .spa-total {
        font-weight: bold;
        display: block;
        font-size: 24px;
        text-align: center;
    }

    .stacked-option {
        width: 20px;
        height: 20px;
        top: 3px;
        position: relative;
        margin-right: 5px;
    }

    .same-time {
        cursor: pointer !important
    }
</style>